import { Interface } from 'ethers';
import { PermitSingle } from '@uniswap/permit2-sdk';

export const PERMIT2_ABI = [
  // Only the permit() we avons besoin
  "function permit(address owner,(address token,uint160 amount,uint48 expiration,uint48 nonce) details,address spender,uint256 sigDeadline,bytes signature)"
];

/**
 * Encode un PermitSingle + signature pour le router OpenOcean.
 * @param owner      adresse qui signe
 * @param permit     objet PermitSingle
 * @param sig        signature hex
 */
export function encodePermitSingle(
  owner: string,
  permit: PermitSingle,
  sig: string
): string {
  const iface = new Interface(PERMIT2_ABI);
  return iface.encodeFunctionData("permit", [
    owner,
    permit.details,
    permit.spender,
    permit.sigDeadline,
    sig
  ]);
}
